export const GT = 'GT';
export const HN = 'HN';
export const SV = 'SV';
export const NI = 'NI';
export const CR = 'CR';
export const PA = 'PA';
export const USA = 'USA';

export const paisActual = GT;
// ['ALL'] if adding all countries.
export const PAISES_MANTENIMIENTO = [];

export const MPC = 'MPC';
export const MCA = 'MCA';
export const MCW = 'MCW';
export const CHATBOT = 'chatbot';

export const COUNTRY = {
  [GT]: {
    money: 'Q',
    lada: '502',
    currency: 'GTQ',
    pais: GT,
    name: 'Guatemala',
    timeZone: 'America/Guatemala'
  },
  [SV]: {
    money: '$',
    lada: '503',
    currency: 'SVC',
    pais: SV,
    name: 'El Salvador',
    timeZone: 'America/El_Salvador'
  },
  [HN]: {
    money: 'L',
    lada: '504',
    currency: 'HNL',
    pais: HN,
    name: 'Honduras',
    timeZone: 'America/Tegucigalpa'
  },
  [NI]: {
    money: 'C$',
    lada: '505',
    currency: 'NIO',
    pais: NI,
    name: 'Nicaragua',
    timeZone: 'America/Managua'
  },
  [CR]: {
    money: 'C',
    lada: '506',
    currency: 'CRC',
    pais: CR,
    name: 'Costa Rica',
    timeZone: 'America/Costa_Rica'
  },
  [PA]: {
    money: '$',
    lada: '507',
    currency: 'PAB',
    pais: PA,
    name: 'Panamá',
    timeZone: 'America/Panama'
  },
  [USA]: {
    money: '$',
    lada: '1',
    currency: 'USD',
    pais: USA,
    name: 'USA',
    timeZone: 'America/New_York'
  }
};

export const COUNTRIES = {
  [GT]: 'gt',
  [HN]: 'hn',
  [NI]: 'ni',
  [SV]: 'sv',
  [CR]: 'cr',
  [PA]: 'pa'
};
export const GTAG_MANAGER = {
  [CR]: {
    code: 'GTM-KZSJQPM',
    successString: 'aricxpago'
  },
  [GT]: {
    code: 'GTM-TT7R2LH',
    successString: 'temxlapago'
  },
  [HN]: {
    code: 'GTM-K4TLG2Z',
    successString: 'durxspago'
  },
  [SV]: {
    code: 'GTM-W8CCXKG',
    successString: 'vadxrpago'
  },
  [NI]: {
    code: 'GTM-K7K3JGM',
    successString: 'rxguapago'
  },
  [PA]: {
    code: 'GTM-P3MJ95G',
    successString: 'namxpago'
  }
};

export const flags = {
  [USA]: 'usa.png',
  [GT]: 'guatemala.png',
  [PA]: 'panama.png',
  [CR]: 'costa-rica.png',
  [HN]: 'honduras.png',
  [SV]: 'el-salvador.png',
  [NI]: 'nicaragua.png'
};

export const NUMBER_TYPE = {
  0: 'Contract',
  1: 'MobileNumber',
  2: 'FixedLine',
  3: 'ClientId',
  4: 'MobileCorp',
  5: 'FixedCorp'
};

export const INVOICE_CONTROLLERS = {
  MPC: 'MpcInvoice',
  MCW: 'McwInvoice'
};
